import { render, staticRenderFns } from "./AiCredits.vue?vue&type=template&id=68b47b8e&"
import script from "./AiCredits.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AiCredits.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports